import { cn } from '@/lib/utils.ts'

interface BetaBadgeProps {
  className?: string
  /** Size variant */
  size?: 'sm' | 'md'
}

/**
 * Badge that indicates a module is in beta status.
 * Rendered in amber/gold color scheme.
 */
export function BetaBadge({ className, size = 'sm' }: BetaBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center font-semibold uppercase tracking-wider rounded',
        size === 'sm'
          ? 'text-[10px] px-1.5 py-0.5'
          : 'text-xs px-2 py-0.5',
        'bg-amber-100 text-amber-700 border border-amber-200',
        className,
      )}
    >
      BETA
    </span>
  )
}
